<!-- Conditions générales d'utilisation — structure + design (contenu à compléter) -->
<template>
    <div class="legal-page">
        <AppHead />

        <main class="legal-page__main">
            <div class="legal-page__hero">
                <div class="legal-page__hero-inner container">
                    <h1 class="legal-page__title">Conditions générales d’utilisation</h1>
                </div>
            </div>

            <div class="legal-page__body container">
                <aside class="legal-page__toc" aria-label="Sommaire">
                    <p class="legal-page__toc-title">Sommaire</p>
                    <nav class="legal-page__toc-nav">
                        <!-- Remplacez les ancres par vos articles réels -->
                        <a href="#article-1">1. Définitions</a>
                        <a href="#article-2">2. Objet</a>
                        <a href="#article-3">3. Accès</a>
                        <a href="#article-4">4. Compte</a>
                        <a href="#article-5">5. Utilisation conforme de l’application</a>
                        <a href="#article-6">6. Nature des contenus et recommandations</a>
                        <a href="#article-7">7. Absence de gestion et de garantie</a>
                        <a href="#article-8">8. Sécurité et disponibilité</a>
                        <a href="#article-9">9. Protection des données personnelles</a>
                        <a href="#article-10">10. Propriété intellectuelle</a>
                        <a href="#article-11">11. Responsabilité de l’utilisateur</a>
                        <a href="#article-12">12. Suspension et suppression du compte</a>
                        <a href="#article-13">13. Évolution de l’application et des CGU</a>
                        <a href="#article-14">14. Droit applicable et juridiction compétente</a>
                    </nav>
                    <router-link class="legal-page__toc-alt" to="/politique-de-confidentialite">
                        Politique de confidentialité →
                    </router-link>
                </aside>

                <article class="legal-page__content">
                    <!-- Préambule -->
                    <section class="legal-block" id="preambule">
                        <h2 class="legal-block__title">Préambule</h2>
                        <div class="legal-block__body">
                            <!-- TODO: coller le préambule CGU ici -->
                            <p>
                                Les présentes Conditions Générales d’Utilisation (ci-après les « CGU ») ont pour objet
                                de
                                définir les modalités et conditions dans lesquelles les utilisateurs accèdent à
                                l’application
                                PATRIMONEA et l’utilisent, éditée par patrimonea by Gwem (ci-après « PBG »), une
                                SAS au Capital de 10 000 000, filiale du Groupe GABRIEL WEALTH MANAGEEMNT, dont
                                le siège social est situé à Abidjan Plateau, Avenue Dr Crozet, 6ᵉ étage, immeuble XL,
                                immatriculée au Registre du Commerce de Côte d’Ivoire (RCCM) sous le numéro CI-ABJ-03-
                                2026-B16-00048, et représentée par Madame Orphée MONNET KEBE en sa qualité de
                                Présidente.<br>
                                L’utilisation de l’application implique l’acceptation pleine et entière des présentes
                                CGU par
                                l’utilisateur.
                            </p>
                        </div>
                    </section>

                    <section class="legal-block" id="article-1">
                        <h2 class="legal-block__title">Article 1 — Définitions</h2>
                        <div class="legal-block__body">
                            <p>
                            <ul>
                                <li>• Application : l’application numérique PATRIMONEA.
                                <li></li>• Utilisateur : toute personne disposant d’un compte actif.</li>
                                <li>• Client : utilisateur ayant souscrit au service d’analyse patrimoniale et de
                                    conseils.</li>
                                <li>• Contenus : ensemble des données, analyses, recommandations, rapports et
                                    informations accessibles via l’application.</li>
                            </ul>
                            </p>
                        </div>
                    </section>

                    <section class="legal-block" id="article-2">
                        <h2 class="legal-block__title">Article 2 — Objet</h2>
                        <div class="legal-block__body">
                            <p>L’application PATRIMONEA a pour objet de permettre aux utilisateurs :
                            <ul>
                                <li>• De renseigner leur situation personnelle, financière et patrimoniale ;</li>
                                <li>• De transmettre des documents justificatifs ;</li>
                                <li>• D’accéder à une analyse patrimoniale et à des recommandations formulées par
                                    patrimonea by Gwem.</li>
                            </ul>
                            L’application constitue un outil d’aide à la décision patrimoniale.</p>
                        </div>
                    </section>

                    <section class="legal-block" id="article-3">
                        <h2 class="legal-block__title">Article 3 — Accès à l’application</h2>
                        <div class="legal-block__body">
                            <p>L’accès à l’application PATRIMONEA est réservé aux utilisateurs disposant d’un compte
                                personnel.
                                <br>L’utilisateur s’engage à fournir des informations exactes lors de la création de son compte et à
                                les maintenir à jour.
                            </p>
                        </div>
                    </section>

                    <section class="legal-block" id="article-4">
                        <h2 class="legal-block__title">Article 4 — Création et gestion du compte</h2>
                        <div class="legal-block__body">
                            <p>Chaque utilisateur dispose d’identifiants strictement personnels.<br>
L’utilisateur est seul responsable de l’utilisation de son compte et de la confidentialité de ses
identifiants.<br>
patrimonea by Gwem, assure l’anonymisation des données du client dès renseignement
sur la plateforme afin de renforcer leur confidentialité vis-à-vis des tiers le cas échéant.<br>
Toute utilisation frauduleuse de ses données et notée par l’utilisateur, devra être signalée sans
délai à patrimonea by Gwem.</p>
                        </div>
                    </section>

                    <section class="legal-block" id="article-5">
                        <h2 class="legal-block__title">Article 5 — Utilisation conforme de l’application</h2>
                        <div class="legal-block__body">
                            <p>L’utilisateur s’engage à utiliser l’application :
                                <ul>
                                    <li>• Conformément à sa destination ;</li>
                                    <li>• Dans le respect des lois et règlements en vigueur ;</li>
                                    <li>• Sans porter atteinte aux droits de patrimonea by Gwem ou de tiers.</li>
                                </ul>
                                Il est notamment interdit de :
                                <ul>
                                    <li>• Détourner l’application de son usage patrimonial ;</li>
                                    <li>• Tenter d’accéder aux systèmes internes ;</li>
                                    <li>• Extraire, copier ou diffuser les contenus sans autorisation.</li>
                                </ul>
                            </p>
                        </div>
                    </section>

                    <section class="legal-block" id="article-6">
                        <h2 class="legal-block__title">Article 6 — Nature des contenus et recommandations</h2>
                        <div class="legal-block__body">
                            <p>Les contenus et recommandations accessibles via l’application :
                                <ul>
                                    <li>• Sont fournis à titre informatif et patrimonial ;</li>
                                    <li>• Reposent sur les informations communiquées par l’utilisateur ;</li>
                                    <li>• Ne constituent ni des ordres d’investissement ni une garantie de performance.</li>
                                </ul>
                            </p>
                        </div>
                    </section>

                    <section class="legal-block" id="article-7">
                        <h2 class="legal-block__title">Article 7 — Absence de gestion et de garantie</h2>
                        <div class="legal-block__body">
                            <p>L’application ne fournit aucun service de gestion discrétionnaire.<br>
L’utilisateur demeure seul responsable des décisions patrimoniales qu’il prend sur la base des
recommandations.<br>
patrimonea by Gwem ne garantit aucun rendement ni résultat financier.</p>
                        </div>
                    </section>

                    <section class="legal-block" id="article-8">
                        <h2 class="legal-block__title">Article 8 — Sécurité et disponibilité</h2>
                        <div class="legal-block__body">
                            <p>[patrimonea by Gwem met en oeuvre des moyens raisonnables pour assurer la sécurité et
la disponibilité de l’application.<br>
Toutefois, l’application peut faire l’objet d’interruptions temporaires pour maintenance ou
raisons techniques.</p>
                        </div>
                    </section>
                    <section class="legal-block" id="article-9">
                        <h2 class="legal-block__title">Article 9 — Protection des données personnelles</h2>
                        <div class="legal-block__body">
                            <p>Les données personnelles traitées dans le cadre de l’application font l’objet d’une Politique de
confidentialité distincte, acceptée par l’utilisateur.<br>
patrimonea by Gwem s’engage à assurer la confidentialité et la sécurité des données
patrimoniales confiées.</p>
                        </div>
                    </section>
                    <section class="legal-block" id="article-10">
                        <h2 class="legal-block__title">Article 10 — Propriété intellectuelle</h2>
                        <div class="legal-block__body">
                            <p>L’application, ses fonctionnalités, contenus, méthodes d’analyse et éléments graphiques sont
protégés par des droits de propriété intellectuelle.<br>
Toute reproduction ou utilisation non autorisée est interdite.</p>
                        </div>
                    </section>
                    <section class="legal-block" id="article-11">
                        <h2 class="legal-block__title">Article 11 — Responsabilité de l’utilisateur</h2>
                        <div class="legal-block__body">
                            <p>L’utilisateur est responsable :
                                <ul>
                                    <li>• De l’exactitude des informations fournies ;</li>
                                    <li>• De la mise à jour de sa situation ;</li>
                                    <li>• De l’usage qu’il fait des recommandations.</li>
                                </ul>
                                Toute conséquence liée à des informations erronées ne saurait engager la responsabilité de
patrimonea by Gwem.
                            </p>
                        </div>
                    </section>
                    <section class="legal-block" id="article-12">
                        <h2 class="legal-block__title">Article 12 — Suspension et suppression du compte</h2>
                        <div class="legal-block__body">
                            <p>patrimonea by Gwem se réserve le droit de suspendre ou supprimer un compte en cas :
                                <ul>
                                    <li>• D’utilisation non conforme ;</li>
                                    <li>• De violation des CGU ;</li>
                                    <li>• De comportement frauduleux.</li>
                                </ul>
                            </p>
                        </div>
                    </section>
                    <section class="legal-block" id="article-13">
                        <h2 class="legal-block__title">Article 13 — Évolution de l’application et des CGU</h2>
                        <div class="legal-block__body">
                            <p>patrimonea by Gwem se réserve le droit de faire évoluer l’application et de modifier les
                                présentes CGU.<br>Toute modification substantielle sera portée à la connaissance des utilisateurs.</p>
                        </div>
                    </section>
                    <section class="legal-block" id="article-14">
                        <h2 class="legal-block__title">Article 14 — Droit applicable et juridiction compétente</h2>
                        <div class="legal-block__body">
                            <p>Les présentes CGU sont soumises au droit ivoirien.<br>
Tout litige qui pourrait naitre de leur interprétation ou exécution sera tranchés définitivement
par la Cour d’Arbitrage de Côte d’Ivoire (CACI).</p>
                        </div>
                    </section>

                    <footer class="legal-page__foot">
                        <router-link to="/" class="legal-page__back">← Retour à l’accueil</router-link>
                    </footer>
                </article>
            </div>
        </main>

        <Footer />
    </div>
</template>

<script>
import AppHead from '@/components/public/AppHead.vue';
import Footer from '@/components/public/Footer.vue';

export default {
    name: 'CGUPage',
    components: { AppHead, Footer },
};
</script>

<style scoped>
.legal-page {
    min-height: 100vh;
    background:
        radial-gradient(ellipse at 12% 0%, rgba(201, 162, 39, 0.1), transparent 48%),
        linear-gradient(180deg, #f7f5f0 0%, #fff 36%);
    color: var(--brand-navy, #01263e);
    font-family: var(--font-body, Georgia, 'Times New Roman', serif);
}

.legal-page__main {
    padding-bottom: 4rem;
}

.legal-page__hero {
    padding: clamp(2.5rem, 6vw, 4rem) 0 clamp(1.75rem, 4vw, 2.5rem);
    border-bottom: 1px solid rgba(1, 38, 62, 0.08);
}

.legal-page__hero-inner {
    max-width: 920px;
}

.legal-page__title {
    margin: 0 0 0.65rem;
    font-family: var(--font-display, Georgia, serif);
    font-size: clamp(1.75rem, 4vw, 2.45rem);
    font-weight: 600;
    line-height: 1.2;
    color: var(--brand-navy, #01263e);
}

.legal-page__body {
    display: grid;
    grid-template-columns: minmax(0, 220px) minmax(0, 1fr);
    gap: clamp(1.5rem, 4vw, 2.75rem);
    max-width: 960px;
    padding-top: clamp(1.75rem, 4vw, 2.75rem);
}

.legal-page__toc {
    position: sticky;
    top: 5.5rem;
    align-self: start;
    padding: 1rem 1.1rem;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.72);
    border: 1px solid rgba(1, 38, 62, 0.08);
    box-shadow: 0 10px 28px rgba(1, 38, 62, 0.04);
}

.legal-page__toc-title {
    margin: 0 0 0.65rem;
    font-size: 0.72rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(1, 38, 62, 0.55);
}

.legal-page__toc-nav {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
}

.legal-page__toc-nav a {
    color: var(--brand-navy, #01263e);
    text-decoration: none;
    font-size: 0.9rem;
    line-height: 1.35;
    font-weight: 600;
}

.legal-page__toc-nav a:hover {
    color: var(--brand-gold, #c9a227);
}

.legal-page__toc-alt {
    display: inline-block;
    margin-top: 1rem;
    padding-top: 0.85rem;
    border-top: 1px solid rgba(1, 38, 62, 0.08);
    font-size: 0.88rem;
    font-weight: 700;
    color: var(--brand-navy, #01263e);
    text-decoration: underline;
}

.legal-page__content {
    min-width: 0;
    background: #fff;
    border: 1px solid rgba(1, 38, 62, 0.08);
    border-radius: 18px;
    padding: clamp(1.35rem, 3vw, 2rem);
    box-shadow: 0 14px 40px rgba(1, 38, 62, 0.05);
}

.legal-block+.legal-block {
    margin-top: 1.75rem;
    padding-top: 1.75rem;
    border-top: 1px solid rgba(1, 38, 62, 0.08);
}

.legal-block__title {
    margin: 0 0 0.75rem;
    font-family: var(--font-display, Georgia, serif);
    font-size: 1.2rem;
    font-weight: 600;
    color: var(--brand-navy, #01263e);
}

.legal-block__body {
    font-size: 0.98rem;
    line-height: 1.65;
    color: rgba(1, 38, 62, 0.92);
}

.legal-block__body :deep(p) {
    margin: 0 0 0.85rem;
}

.legal-block__body :deep(ul),
.legal-block__body :deep(ol) {
    margin: 0 0 0.85rem;
    padding-left: 1.2rem;
}

.legal-block__body :deep(a) {
    color: var(--brand-navy, #01263e);
    font-weight: 700;
}

.legal-block__placeholder {
    margin: 0;
    padding: 0.85rem 1rem;
    border-radius: 10px;
    background: #f8fafc;
    border: 1px dashed rgba(1, 38, 62, 0.18);
    color: rgba(1, 38, 62, 0.45);
    font-style: italic;
}

.legal-page__foot {
    margin-top: 2.25rem;
    padding-top: 1.25rem;
    border-top: 1px solid rgba(1, 38, 62, 0.08);
}

.legal-page__back {
    font-weight: 700;
    color: var(--brand-navy, #01263e);
    text-decoration: none;
}

.legal-page__back:hover {
    color: var(--brand-gold, #c9a227);
}

@media (max-width: 860px) {
    .legal-page__body {
        grid-template-columns: 1fr;
    }

    .legal-page__toc {
        position: static;
    }
}
</style>
